<script>
import {
  formatThousands
} from '@/utils/helpers'
import {
  rexText
} from '@/components/views/rexField'

export default {
  name: 'payment-form',
  components: {
    rexText
  },
  computed: {
    isLoading() {
      return this.$store.getters['payment/billingForm'].isLoading
    },
    billingDetails() {
      return this.$store.getters['payment/billingData'].details
    },
    billingForm() {
      return this.$store.getters['payment/billingForm'].formData
    },
    sumWithCommission() {
      return this.billingForm.amount + this.commission
    },
    commission() {
      const {
        commission
      } = this.billingDetails

      const commissionValue = this.billingForm.amount * (commission / 100)

      return Math.round(commissionValue)
    }
  },
  methods: {
    formatThousands,
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('payment/setBillingForm', {
            isLoading: true
          })

          const { formData } = this.$store.getters['payment/billingForm']
          const {
            orderId,
            serviceName
          } = this.billingDetails

          this.$store.dispatch('payment/getBillingLink', {
            orderId,
            params: {
              ...formData,
              serviceName
            }
          })
        }
      })
    }
  }
}
</script>
<template>
  <div class="payment-form">
    <div class="payment-form__summ">
      <rex-text
        label="Оплатите всю сумму или скорректируйте."
        store-module="payment"
        getter-name="getField"
        setter-name="setField"
        target="billingForm.formData.amount"
        name="orderPaymentSumm"
        type="number"
        :disabled="isLoading"
        :validate="{
          required: true,
          min_value: 1,
          max_value: billingDetails.amount
        }"
      />
      <div class="payment-form__summ-commission">
        <p>
          Комиссия {{ billingDetails.commission }}% - {{ formatThousands(commission) }} ₽
        </p>
        <p>
          Сумма оплаты с учётом комиссии - {{ formatThousands(sumWithCommission) }} ₽
        </p>
      </div>
    </div>
    <rex-text
      label="ФИО плательщика"
      store-module="payment"
      getter-name="getField"
      setter-name="setField"
      target="billingForm.formData.name"
      name="orderPaymentPayerName"
      :disabled="isLoading"
      :validate="{
        required: true
      }"
    />
    <rex-text
      label="Электронная почта (для получения чека)"
      store-module="payment"
      getter-name="getField"
      setter-name="setField"
      target="billingForm.formData.email"
      name="orderPaymentPayerEmail"
      :disabled="isLoading"
      :validate="{
        required: true,
        email: true
      }"
    />
    <div class="payment-form__actions">
      <button
        class="rex-button rex-button--filled rex-button--filled-red"
        :class="{
          'rex-button--disabled rex-button--hide-text': isLoading
        }"
        :disabled="isLoading"
        @click="submit"
      >
        <b-loading
          :is-full-page="false"
          :active="isLoading"
        />
        <span>
          Оплатить
        </span>
      </button>
    </div>
  </div>
</template>